<script>
    export default {
        name: "BaseTextarea",
        props: {
            name: String,
            value: {
                type: String,
            },
            placeholder: {
                type: String,
                default: "",
            },
            /** @type {import('vue').PropOptions<"primary" | "secondary">} */
            variant: {
                type: String,
                default: "primary",
                validator: (value) => {
                    return ["primary", "secondary"].includes(value);
                },
            },
            errorText: String,
            minHeight: {
                type: Number,
                default: 180,
            },
            maxLength: Number,
        },
        computed: {
            classNames() {
                return [
                    this.errorText ? "base-input--error" : "",
                    String(this.value).length > 0 ? "base-input--active" : "",
                    this.variant === "primary"
                        ? "base-input--primary"
                        : "base-input--secondary",
                ];
            },
        },
        methods: {
            keyupElement({ key }) {
                if (key !== "Enter") {
                    this.error = "";
                    this.$emit("error", this.name);
                }
            },
        },
    };
</script>

<template>
    <label class="base-textarea">
        <textarea
            :value="value"
            class="base-textarea__field base-input__field"
            :class="classNames"
            :style="{ minHeight: `${minHeight}px` }"
            :name="name"
            :placeholder="placeholder"
            :maxlength="maxLength"
            @input="$emit('input', $event.target.value)"
            @keyup="keyupElement"
        ></textarea>
        <span v-if="errorText" class="base-textarea__error">
            {{ errorText }}
        </span>
    </label>
</template>

<style lang="scss">
    .base-textarea {
        display: block;
    }

    .base-textarea__field {
        display: block;
        width: 100%;
        margin-top: 12px;
        resize: vertical;
        outline: none;
    }

    .base-textarea__error {
        display: block;
        margin-top: 4px;
        padding-left: 12px;
        font-size: 12px;
        line-height: 16px;
        color: var(--input-text-color--error);
        text-align: left;
    }
</style>
